export const BILLING_TYPES = {
    FIXED_VALUE: 'fixed_value',
    PER_ACTIVE_USER: 'per_active_user',
    USER_RANGE: 'user_range',
}

export const BILLING_TYPE_LABELS = {
    [BILLING_TYPES.FIXED_VALUE]: 'Valor Fixo',
    [BILLING_TYPES.PER_ACTIVE_USER]: 'Por Usuário Ativo',
    [BILLING_TYPES.USER_RANGE]: 'Por Faixa de Usuários',
}

export const BILLING_TYPE_OPTIONS = [
    { value: null, label: 'Não configurado' },
    { value: BILLING_TYPES.FIXED_VALUE, label: BILLING_TYPE_LABELS[BILLING_TYPES.FIXED_VALUE] },
    { value: BILLING_TYPES.PER_ACTIVE_USER, label: BILLING_TYPE_LABELS[BILLING_TYPES.PER_ACTIVE_USER] },
    { value: BILLING_TYPES.USER_RANGE, label: BILLING_TYPE_LABELS[BILLING_TYPES.USER_RANGE] },
]

export const DEFAULT_PERIOD_START_DAY = 1
export const DEFAULT_PERIOD_END_DAY = 20
